// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__JJHje","paramInput":"JobSimulator_paramInput__1AO6M","input":"JobSimulator_input__3jIwk"};